import { Injectable } from '@angular/core';
import { AppConfigService, constants, FEATURE_FLAGS, HybridAppService, LocalStorageService } from '@edassist/common';
import { AuthenticationService } from '../services/auth/auth.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({ providedIn: 'root' })
export class HybridAuthGuard {
	constructor(
		private readonly authenticationService: AuthenticationService,
		private readonly hybridAppService: HybridAppService,
		private readonly authService: AuthService
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
		return this.authenticationService.isAuthenticated$.pipe(
			first(),
			map((isAuthenticated) => {
				if (isAuthenticated) {
					return true;
				}

				const redirectURL = route['_routerState'].url;
				const clientId = LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS)?.clientId;
				if (clientId && AppConfigService.featureFlagForClientIds(FEATURE_FLAGS.NEW_LOGIN_UI_ENABLED, clientId)) {
					this.authService.loginWithRedirect({
						appState: {
							target: redirectURL
						}
					});
				} else {
					this.hybridAppService.navigateToBaseLogin({ redirectURL });
				}

				return false;
			})
		);
	}
}
